import type { Router } from 'vue-router'

type Translate = (key: string, named?: Record<string, unknown>) => string

/**
 * Writes the document title after each navigation from the `titleKey` of the
 * route, as "Page · Tendly". A route with no key shows the name of the
 * application only.
 */
export function installDocumentTitle(router: Router, t: Translate): void {
  router.afterEach((destination) => {
    const key = destination.meta.titleKey
    const app = t('app.name')
    document.title = key === undefined ? app : t('app.documentTitle', { page: t(key), app })
  })
}

/**
 * Writes the document title of a page whose name comes from the API, such as
 * the title of an article, in the same form as the route titles.
 */
export function writePageTitle(page: string, t: Translate): void {
  document.title = t('app.documentTitle', { page, app: t('app.name') })
}
